var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 125,
    viewBox: "0 0 92 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8836_20337)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.721191,
    width: 182.288,
    height: 124.724,
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 54.3662,
    width: 27.1834,
    height: 3.19804,
    rx: 1.59902,
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 59.1621,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 62.3604,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 65.5586,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 68.7568,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 71.9541,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 75.1523,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 78.3506,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 81.5488,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 84.7461,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 87.9443,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 91.1436,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 94.3418,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 97.5391,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 100.737,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 103.936,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 107.134,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 110.332,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3154,
    y: 113.529,
    width: 71.956,
    height: 1.59902,
    rx: 0.799511,
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3152,
    y: 9.59473,
    width: 71.956,
    height: 39.9756,
    rx: 3.19804,
    fill: "#6C757D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5231 22.8778C36.6199 21.9226 37.2762 21.1954 38.2245 21.0457C39.4895 20.846 41.7129 20.6313 45.4256 20.6313C49.1384 20.6313 51.3617 20.846 52.6267 21.0457C53.5751 21.1954 54.2314 21.9226 54.3282 22.8778C54.4091 23.6759 54.4882 24.8442 54.5206 26.4999C54.687 26.7618 54.7832 27.0714 54.7832 27.4031C54.7832 27.7247 54.6928 28.0254 54.5357 28.2821C54.5325 30.3658 54.4603 31.8462 54.3758 32.8697C54.5223 32.9432 54.6636 33.0346 54.7969 33.1432C55.4218 33.6519 56.3306 34.436 57.5995 35.6236C57.5734 35.9745 57.5458 36.2804 57.5182 36.5454C57.4193 37.4975 56.7707 38.2282 55.8266 38.3862C54.5049 38.6072 52.1327 38.8517 48.1054 38.8517C44.078 38.8517 41.7058 38.6072 40.3842 38.3862C39.4401 38.2282 38.7915 37.4975 38.6925 36.5454C38.6596 36.2284 38.6266 35.853 38.5961 35.4121C38.638 35.3724 38.6797 35.333 38.7211 35.294C38.5412 35.2701 38.376 35.246 38.2245 35.222C37.2762 35.0724 36.6199 34.3452 36.5231 33.39C36.4178 32.3512 36.3154 30.6852 36.3154 28.1339C36.3154 25.5825 36.4178 23.9165 36.5231 22.8778Z",
    fill: "#ADB5BD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6902 25.0733C38.7897 24.1197 39.4419 23.3894 40.3879 23.2334C41.7102 23.0154 44.0817 22.7744 48.1053 22.7744C52.1289 22.7744 54.5004 23.0154 55.8228 23.2334C56.7688 23.3894 57.4209 24.1197 57.5205 25.0733C57.6357 26.1775 57.7514 27.989 57.7514 30.8128C57.7514 33.6366 57.6357 35.4482 57.5205 36.5524C57.4209 37.506 56.7688 38.2363 55.8228 38.3923C54.5004 38.6103 52.1289 38.8512 48.1053 38.8512C44.0817 38.8512 41.7102 38.6103 40.3879 38.3923C39.4419 38.2363 38.7897 37.506 38.6902 36.5524C38.5749 35.4482 38.4592 33.6366 38.4592 30.8128C38.4592 27.989 38.5749 26.1775 38.6902 25.0733ZM57.5997 35.6231C57.5736 35.974 57.546 36.2799 57.5184 36.5449C57.4195 37.497 56.7709 38.2277 55.8268 38.3856C54.5051 38.6067 52.133 38.8512 48.1056 38.8512C44.0782 38.8512 41.7061 38.6067 40.3844 38.3856C39.4403 38.2277 38.7917 37.497 38.6928 36.5449C38.6598 36.2279 38.6268 35.8525 38.5963 35.4115C40.7427 33.3786 42.2327 32.2457 43.1711 31.6257C43.9453 31.1143 44.892 31.2006 45.6105 31.7855C46.3941 32.4233 47.6236 33.494 49.4499 35.2501C50.7285 34.1356 51.6849 33.4274 52.3578 32.9828C53.1319 32.4714 54.0786 32.5578 54.7972 33.1427C55.4221 33.6514 56.3308 34.4355 57.5997 35.6231ZM54.7834 27.4026C54.7834 28.3443 54.0083 29.1077 53.0521 29.1077C52.0959 29.1077 51.3207 28.3443 51.3207 27.4026C51.3207 26.4609 52.0959 25.6975 53.0521 25.6975C54.0083 25.6975 54.7834 26.4609 54.7834 27.4026Z",
    fill: "#DEE2E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8836_20337"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.721191,
    width: 91.1442,
    height: 124.724,
    rx: 4.79707,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.ddd3b8b2e0522d9e48c0b5f985ff7731.svg";
export { ForwardRef as ReactComponent };